import { Maybe, Site } from '@csp/csp-common-model';

export type SiteDetailsContextState = {
  site: Maybe<Site>;
};

const emptyState = (): SiteDetailsContextState => ({
  site: undefined,
});

export const SiteDetailsContextState = {
  emptyState,
};
